import { deferUntilPermitted, DIDOMI_ANALYTICS_PURPOSE_ID, THE_CONVERSATION_VENDOR_ID, } from "../Didomi";
import { nonProdLogger } from "../nonProdLogger";
const ARTICLE_TRACKING_ID = "articleReadList";
let localArticleCount = 0;
/**
 * Future requirements:
 * To properly implement the requirements of the Braze project, this system will need
 * a method to expire articles read >30 days ago. I imagine this will require storing
 * an array of timestamps, and then every time the count is checked it also discards
 * any timestamps that are too old. After that it returns the size of the array.
 */
/**
 * Returns total articles read.
 */
export function getTotalArticles() {
    try {
        const rawVal = window.localStorage.getItem(ARTICLE_TRACKING_ID) || "{}";
        const decodedVal = JSON.parse(rawVal);
        const storedCount = parseInt(decodedVal.total || "0");
        return Math.max(storedCount, localArticleCount);
    }
    catch {
        return localArticleCount;
    }
}
/**
 * Tries to increment the number of articles read by this user, but waits for Didomi
 * permission before actually storing the data in the their browser.
 *
 * This function will work correctly once, and once only, if Didomi permission is
 * not granted. If called repeatedly without that permission, it will just keep
 * setting the number of articles to 1. However as users cannot read more than
 * one article per page in the current CMS, this is not a problem.
 */
export function incrementTotalArticles(currentArticleId) {
    try {
        const rawVal = window.localStorage.getItem(ARTICLE_TRACKING_ID) || "{}";
        const decodedVal = JSON.parse(rawVal);
        const previousTotal = parseInt(decodedVal.total || "0");
        const recentArticles = decodedVal.recentArticles || [];
        if (recentArticles.includes(currentArticleId)) {
            localArticleCount = previousTotal;
            return;
        }
        recentArticles.push(currentArticleId);
        if (recentArticles.length > 10)
            recentArticles.shift();
        const newTotal = {
            total: previousTotal + 1,
            recentArticles: recentArticles,
        };
        deferUntilPermitted(THE_CONVERSATION_VENDOR_ID, DIDOMI_ANALYTICS_PURPOSE_ID, () => window.localStorage.setItem(ARTICLE_TRACKING_ID, JSON.stringify(newTotal)));
        localArticleCount = newTotal.total;
    }
    catch (err) {
        if (err instanceof Error) {
            nonProdLogger(`Error incrementing article count: ${err.message}`);
        }
        else {
            nonProdLogger("Error incrementing article count");
        }
    }
}
